<template>
  <div class="slideshow-banner" v-if="enabled">
    <!-- The family's chosen image stays as it is; a click anywhere on it opens the slideshow. -->
    <button
      class="slideshow-banner__open"
      tabindex="-1"
      type="button"
      :aria-label="texts.bannerOpen"
      @click="open"
    />
    <button class="slideshow-banner__pill" type="button" @click="open">
      <span class="slideshow-banner__text">
        <b>
          <SlideshowIcon name="play" />
          {{ texts.heading }}
        </b>
      </span>
    </button>
  </div>
</template>

<script lang="ts" setup>
  import {
    hasSlideshow,
    openViewer,
    slideshowTexts,
  } from "../../composables/useSlideshow";
  import SlideshowIcon from "./SlideshowIcon.vue";

  const texts = slideshowTexts();
  // A page without a slideshow keeps its hero as it is, with no way into one.
  const enabled = hasSlideshow();
  // Called without arguments: the viewer opens at the start.
  const open = () => openViewer({ source: "hero" });
</script>
